import * as React from 'react'

import Loading from 'modules/core/components/Loading'
import { Panes } from 'modules/core/components/Panes'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import FieldsCollection from 'modules/custom_resources/store/collections/customResources/fields'
import { SchemasCollection } from 'modules/custom_resources/store/collections/customResources/schemas'
import Schema from 'modules/custom_resources/store/models/customResources/Schema'

import CustomTableSettings from './Content/CustomTableSettings'
import RatingSettings from './Content/RatingSettings'

const CompetenciesBundleSettings = () => {
  const fields = React.useRef(new FieldsCollection()).current
  const schemas = React.useRef(new SchemasCollection()).current

  const { loading } = useAsyncData(async () => {
    await schemas.fetch({
      data: {
        topic_names: [Schema.TOPIC_NAMES.performance],
      },
    })

    const competenciesSchema = schemas.find({
      name: Schema.SCHEMA_NAMES.competencies,
    })
    await fields.fetch({
      data: {
        schema_ids: [competenciesSchema?.id],
      },
    })
  }, [])

  const schema = schemas.find({
    name: Schema.SCHEMA_NAMES.competencies,
  })

  const ratingField = fields.find({
    field_type: FieldTypes.rating,
  })

  if (loading) return <Loading />
  if (!schema || !ratingField) return null

  return (
    <Panes direction="vertical">
      <CustomTableSettings schema={schema} />
      <RatingSettings field={ratingField} />
    </Panes>
  )
}

export default CompetenciesBundleSettings
